// extracted by mini-css-extract-plugin
export default {"cardItem":"HorizontalScroll_cardItem__Eohea"};